var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4867 0L28.3042 7.98489L28.3174 23.978L14.5131 31.9863L0.695611 24.0009L0.682373 8.00778L14.4867 0Z",
    fill: "url(#paint0_linear_932_7357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7371 19.8547C15.7371 19.8547 18.4347 22.5523 18.6285 22.7461C19.2525 23.3701 20.2635 23.3701 20.8869 22.7461C21.5109 22.1221 21.5109 21.1111 20.8869 20.4871C20.6931 20.2933 17.9955 17.5957 17.9955 17.5957L15.7371 19.8547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0812 13.6156L18.1606 13.1356L17.6806 11.215L19.9042 8.99136C18.6268 8.58516 17.1736 8.88576 16.1602 9.89856C14.7142 11.3446 15.1768 13.2268 16.6234 14.6728C18.0694 16.1188 19.9516 16.582 21.3976 15.1354C22.411 14.122 22.7116 12.6688 22.3048 11.392L20.0812 13.6156Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1823 13.9135L11.0823 11.8135L10.4823 10.0135L8.08232 8.81348L6.88232 10.0135L8.08232 12.4135L9.88232 13.0135L11.9823 15.1135L13.1823 13.9135Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4097 12.3408C14.3913 14.3592 8.82808 19.9224 8.60968 20.1408C7.90648 20.844 7.90648 21.9834 8.60968 22.6866C9.31288 23.3898 10.4523 23.3898 11.1555 22.6866C11.3739 22.4682 16.9371 16.905 18.9555 14.8866L16.4097 12.3408ZM9.88228 22.0134C9.55108 22.0134 9.28228 21.7446 9.28228 21.4134C9.28228 21.0822 9.55108 20.8134 9.88228 20.8134C10.2135 20.8134 10.4823 21.0822 10.4823 21.4134C10.4823 21.7446 10.2135 22.0134 9.88228 22.0134Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_7357",
    x1: 0.682386,
    y1: 4.99999,
    x2: 18.0415,
    y2: 34.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C39EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.5ef8cc1901ed982bea2e22b6970167d6.svg";
export { ForwardRef as ReactComponent };